<template>
  <div class="automation-step-1">
    <select-button :src="item.icon" :label="item.text"  @click="selectTrigger(item.id)"
                   v-for="item in triggers" :key="item.id" :value="item.id"
                   v-model="selected"/>
  </div>
</template>

<script>
import {mapGetters} from "vuex"
import SelectButton from "@/components/base/select_button";
export default {
    name: "Step1",
	components: {SelectButton},
	data() {
    return {
      selected: false,
      triggers: [{
        id: 1,
        icon: require('@/assets/img/tg-icon-1.svg'),
        text: "Purchase",
        active: false
      },
        {
	        id: 2,
	        icon: require('@/assets/img/tg-icon-2.svg'),
	        text: "Refund",
	        active: false
        },
        {
	        id: 3,
	        icon: require('@/assets/img/tg-icon-3.svg'),
	        text: "New subscription",
	        active: false
        },
        {
	        id: 4,
	        icon: require('@/assets/img/tg-icon-4.svg'),
	        text: "Subscription canceled",
	        active: false
        }
      ],
    }
    },
    computed: {
    },
    props: {
			automation:{
				type:Object
			}
    },
    methods: {
	    selectTrigger(id) {
		    this.selected = id;
		    this.$emit('done', id);
	    }
    },
	created() {
		if (this.automation) {
			this.selected = this.automation.trigger_id
		}
	}
}
</script>

<style  lang="scss" scoped>
.automation-step-1 {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
	grid-gap: 10px;
	.select-button {
		width: 100%;
		.item {
			width: 100%;
		}
	}
}
</style>
